const CORRELATION_ID_KEY = 'mentis_correlation_id';

export function getCorrelationId(): string {
  let id = sessionStorage.getItem(CORRELATION_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(CORRELATION_ID_KEY, id);
  }
  return id;
}
